{
  "common": {
    "for": "pour",
    "each": "chacun",
    "eachLot": "Chaque lot",
    "lot": "lot",
    "lots": "lots",
    "selectAll": "Choisir TOUS",
    "unselectAll": "Retirer TOUS"
  },
  "pageHeader": {
    "techSupport": "Support Technique",
    "auctionCompany": "Firme d'encan",
    "welcome": "Bienvenue",
    "bidder": "Enchérisseur",
    "viewer": "Regarder seulement",
    "fullCatalog": "Voir tout le catalogue"
  },
  "catalogAndMyPurchases": {
    "firstTab": "Catalogue",
    "secondTab": "Mes achats",
    "trackLots": "Permettre de suivre les lots du catalogue",
    "backToLots": "Retour aux lots",
    "passed": "Retiré de la vente",
    "pending": "En attente",
    "sold": "Vendu",
    "biddingNow": "Misez maintenant",
    "upNext": "Prochain",
    "confirmPurchases": "Tous les achats doivent être confirmés par L'Encanteur",
    "lot": "Lot",
    "backToMyPurchases": "Retour à mes achats"
  },
  "chat": {
    "loading": "Téléchargement discussion en ligne ...",
    "header": "Discussion en ligne"
  },
  "mediaStreaming": {
    "failedConnection": "Connexion échouée!",
    "playBtn": "Mettre en marche média en ligne",
    "connecting": "Connexion en cours ...",
    "unmute": "Enlever son muet",
    "mute": "Mettre son muet",
    "tooltip": "Vous êtes connecté au streaming"
  },
  "biddingArea": {
    "auctionPaused": "Encan arrêté pour quelques instant",
    "waitingAuctionToStart": "En attente du début de l' Encan",
    "waitingBiddingToStart": "En attente du début pour miser",
    "auctioneerConfirmed": "L'Encanteur vous donne",
    "soldPriceForEach": "Prix vendu par lot (prix unitaire):",
    "winningBid": "Vous êtes le GAGNANT de ce lot",
    "pendingSellerConfirmationForEach": "En attente de confirmation du prix de chacun des lots",
    "pendingBid": "En attente de la mise",
    "auctioneerRefused": "L'Encanteur ne vous a pas vendu ce lot",
    "sold": "VENDU!",
    "pendingSellerConfirmation": "En attente de confirmation de la vente.",
    "bid": "MISEZ",
    "roundCancelled": "Annulé",
    "noSale": "Annulé aucune mise",
    "highestBidder": "FÉLICITATIONS VOUS ËTES LE GAGNANT !",
    "youWon": "FÉLICITATIONS VOUS ËTES LE GAGNANT !",
    "waitingWinner": "Waiting for the winner to choose the lots…",
    "totalPrice": "Total Price",
    "yourBidPending": "Your bid is pending seller confirmation",
    "waitingWinnerChooseLots": "En attente du choix de lots de l' acheteur gagnant…",
    "youAreIn": "Vous êtes connecté!",
    "viewOnly": "Regarder seulement! ",
    "registerLogin": "S'inscrire/Se connecter ",
    "clickToBid": "Cliquer pour pouvoir miser ",
    "swipeToBid": "Glisser pour miser ",
    "waitingIncrement": "En attente confirmation du nombre",
    "totalBid": "Votre mise totale",
    "bidHistory": "Votre historique de mises effectuées",
    "floorFirst": "Vente en personne sur place d' abord",
    "waitAuctioneer": "Veuillez attendre confirmation de Votre choix",
    "makeSelections": "S.V.P. Faites Votre choix",
    "pricePendingConfirmation": "En attente de confirmation du prix de chacun des lots",
    "selectionSent": "Votre choix effectué et envoyé",
    "sendSelection": "Cliquer Votre choix"
  },
  "currentRound": {
    "nowBidding": "Mise maintenant disponible",
    "scrollList": "Dérouler et regarder liste ci-bas"
  },
  "webcastFinished": "L'evenement de webcast est termine. Merci."
}
